export const
    isSegregatedClientAvailable = (state, clientId) => {
        return state.hasOwnProperty('currentClientId')
            && ADV.util.isNumeric(state.currentClientId)
            && clientId.toString() === state.currentClientId.toString();
    };